import { NgClass, NgTemplateOutlet } from "@angular/common";
import {
    AfterViewInit,
    Component,
    computed,
    contentChild,
    ContentChild,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
    ChangeDetectionStrategy
} from "@angular/core";
import { asapScheduler } from "rxjs";
import { BusySpinnerComponent } from "../busy/busy-spinner/busy-spinner.component";
import { HeaderComponent } from "../header/header.component";
import { HelpiconComponent } from "../helpicon/helpicon.component";
@Component({
    selector: "rask-toggle-panel",
    templateUrl: "./toggle-panel.component.html",
    styleUrls: ["./toggle-panel.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        HeaderComponent,
        HelpiconComponent,
        BusySpinnerComponent,
        NgTemplateOutlet
    ]
})
export class TogglePanelComponent implements AfterViewInit {
    header = contentChild<TemplateRef<ElementRef>>("header");
    showHeader = computed<boolean>(() => this.isEmpty(this.header()?.elementRef));

    @ContentChild("customHeader") customHeader: ElementRef;

    @Input() size = "3";

    @Input() label: string;

    @Input() disabled: boolean;

    @Input() aid: string;

    @Input() icon: string;

    @Input() validationIcon: string;

    @Input() showLoader = false;

    @Input() noPadding = false;

    @Input() enableBackdrop = false;

    @Input() helpUrl: string;

    @Input()
    set defaultExpanded(val: boolean) {
        this.expanded = !!val;
    }

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("badgeText") set badgeInput(val: string) { this.badge = val; }

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

    protected showCustomHeader: boolean;
    protected expanded = false;
    protected badge: string;

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.showCustomHeader = !!this.customHeader;
        });
    }

    forceExpandedState(expanded: boolean) {
        if (this.expanded !== expanded) {
            asapScheduler.schedule(() => this.setExpandedState(expanded));
        }
    }

    protected getPanelBodyClass(): string {
        if (this.enableBackdrop) {
            return "panel-body";
        }

        return this.noPadding ? "panel-body-no-padding" : "panel-body";
    }

    protected toggle(): void {
        this.setExpandedState(!this.expanded);
    }

    private setExpandedState(expanded: boolean) {
        if (this.disabled) {
            return;
        }
        if (this.expanded !== expanded) {
            this.expanded = expanded;
            this.onToggle.emit(this.expanded);
        }
    }

    private isEmpty(element: ElementRef) {
        return !element || !element.nativeElement || element.nativeElement.childNodes.length === 0;
    }
}
